module.exports = __webpack_public_path__ + "img/Extra999.4d36e68c.png";